import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeService {

  constructor() { }

  isMobile(): boolean {
    return /iPhone|Android.*Mobile|Windows Phone/i.test(navigator.userAgent);
  }

  isTablet(): boolean {
    return /iPad|Android(?!.*Mobile)/i.test(navigator.userAgent);
  }

  isDesktop(): boolean {
    return !this.isMobile() && !this.isTablet();
  }

  getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    if (this.isMobile()) return 'mobile';
    if (this.isTablet()) return 'tablet';
    return 'desktop';
  }

  getUserSource(): 'android_web' | 'ios_web' | 'mobile_web' | 'web' {
    const userAgent = navigator.userAgent.toLowerCase();

    const screenWidth = window.innerWidth;

    const isAndroid = /android/.test(userAgent);
    const isIOS = /ipad|iphone|ipod/.test(userAgent);

    if (isAndroid) {
      return 'android_web'; // actual Android device
    } else if (isIOS) {
      return 'ios_web';     // actual iOS device
    } else if (screenWidth <= 767) {
      return 'mobile_web';  // mobile viewport
    } else {
      return 'web';         // regular desktop
    }
  }

}
